import * as React from 'react';
import classNames from 'classnames';
import * as _ from 'lodash-es';
import {  } from 'react-router-dom';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import Paper from '@mui/material/Paper';

import TravelerTableHead from 'components/TravelersList/TravelerTableHead';
import TravelerTableRow from 'components/TravelersList/TravelerTableRow';
import Loader from 'components/Loader/Loader';

import { connectWithRouter } from 'helpers/connectWithRouter';
import { get, emptyResults, Params } from 'actions/Travelers/Get';
import { bindActionCreators, Dispatch } from 'redux';
import { QUERY_LIMIT } from '../../../configs/General';
import { ReduxState, Traveler } from '../../../reducers/types';

const styles = require('./styles.pcss');
type Props = any;

type State = {
  searchKeyword: string;
};

const appWindow: Window = window;

class TravelersBody extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      searchKeyword: '',
    };

    this.handleScroll = this.handleScroll.bind(this);
  }

  navigate = (path: string) => {
    this.props.navigate(path);
  };

  componentWillReceiveProps = (nextProps: any) => {
    if (_.get(nextProps, 'travelers', []).length === 1) {
      const urlParams = new URLSearchParams(window.location.search);
      const email = (urlParams.get('email') ?? '').toLowerCase();
      const firstName = (urlParams.get('firstName') ?? '').toLowerCase();
      const lastName = (urlParams.get('lastName') ?? '').toLowerCase();

      if (
        nextProps.travelers[0].email.toLowerCase() === email ||
        nextProps.travelers[0].lastName.toLowerCase() === lastName ||
        nextProps.travelers[0].firstName.toLowerCase() === firstName
      ) {
        this.navigate(`/users/${nextProps.travelers[0].userId}`);
      }
    }
  };

  handleScroll() {
    const body = document.body;
    const html = document.documentElement;

    if (!body || !html) {
      return;
    }

    const windowHeight =
      'innerHeight' in appWindow ? appWindow.innerHeight : html.offsetHeight;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight,
    );
    const windowBottom = windowHeight + window.pageYOffset;

    if (
      windowBottom >= docHeight &&
      this.props.isLoading === false &&
      this.props.loadedAll === false
    ) {
      const params: any = {
        limit: QUERY_LIMIT,
        skip: this.props.travelers.length,
        ...this.props.searchParams,
      };

      this.props.get(params);
    }
  }

  componentDidMount() {
    appWindow.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    appWindow.removeEventListener('scroll', this.handleScroll);
    this.props.emptyResults();
  }

  renderTableRow = (traveler: any, i: number) => {
    return (
      <TravelerTableRow
        traveler={traveler}
        lookup={true}
        navigate={this.props.navigate}
      />
    );
  };

  render() {
    if (this.props.travelers.length == 0 && this.props.loadedAll) {
      return (
        <Paper className={styles.bodyPaper}>
          <div className={styles.notFound}>No records found</div>
        </Paper>
      );
    }

    if (this.props.travelers.length == 0) {
      return (
        <Loader
          visible={this.props.isLoading}
          id="travelerLoader"
        />
      );
    }

    return (
      <Paper className={styles.bodyPaper}>
        <Loader
          visible={this.props.isLoading}
          id="travelerLoader"
        />
        <Table>
          <TravelerTableHead lookup={true} />
          <TableBody>{this.props.travelers.map(this.renderTableRow)}</TableBody>
        </Table>
      </Paper>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      get,
      emptyResults,
    },
    dispatch,
  );
}

function mapStateToProps(state: ReduxState) {
  return {
    travelers: state.travelers.travelers,
    isLoading: state.travelers.isLoading,
    loadedAll: state.travelers.loadedAll,
  };
}

export default connectWithRouter(
  mapStateToProps,
  mapDispatchToProps,
)(TravelersBody);
